








import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from "vue-property-decorator";

/**
 * Botón de archivo
 *
 * Un pequeño componente que muestra un botón para abrir el explorador
 * de archivo y seleccionar uno
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class FileButton extends Vue {
    @Prop({type: String, default: '*/*'})
    public accept: string

    public $refs: {
        fileInput: HTMLInputElement;
    }

    public onFile (event: Event) {
        const input = event.target as HTMLInputElement

        if (input.files && input.files.length) {
            this.$emit('input', input.files)
        }
    }
}
